import React from 'react';
var ConfigContext = /*#__PURE__*/React.createContext({});
ConfigContext.displayName = 'UseRequestConfigContext';
export default ConfigContext;


//////////////////
// WEBPACK FOOTER
// ./~/@ahooksjs/use-request/es/configContext.js
// module id = 1550
// module chunks = 2